import { getSellerCommunicationEnquiries } from 'Pages/api/seller-communications/enquiries/client.api';
import { triggerSellerMessagingSelectAllCheckboxClickedEvent } from 'Services/analytics/events';
import { logger } from 'Services/logger/logger';

import { filterEnquiries } from './helpers';
import { modalService } from './modalService';
import { EnquiriesSearchStore, EnquiriesSelectStore, EnquiriesStore, ModalFlowStore } from './stores';
import { ModalSteps } from './types';

export const onCreateEmailClick = () => {
	ModalFlowStore.setState({ currentStep: ModalSteps.EmailEditor });
};

export const onMarkAsContactedClick = () => {
	ModalFlowStore.setState({ currentStep: ModalSteps.MarkAsContactedConfirmation });
};

export const onGetCommunicationData = async () => {
	try {
		const { hasMoreItems, items } = await getSellerCommunicationEnquiries();

		if (!items.length) {
			ModalFlowStore.setState({ currentStep: ModalSteps.NothingToSend });
		} else {
			EnquiriesStore.setState({
				enquiries: items,
				enquiriesMap: items.reduce((acc, sale) => ({ ...acc, [sale.enquiryId]: sale, [sale.saleId]: sale }), {}),
				hasMoreItems,
			});
			ModalFlowStore.setState({ currentStep: ModalSteps.EnquirySelection });
		}
	} catch (error) {
		ModalFlowStore.setState({ currentStep: ModalSteps.EnquirySelectionError });
		logger.error({
			error: error as Error,
			message: 'Failed to fetch enquiries',
			scope: 'getSellerCommunicationData',
		});
	}
};

const onRefetchCommunicationData = () => {
	modalService.onNavigate(ModalSteps.EnquirySelectionLoading);
	void onGetCommunicationData();
};

export const onSearchChange = (keyword: string) => {
	const { enquiries } = EnquiriesStore.getState();
	const filteredSaleIds = filterEnquiries(enquiries, keyword);
	EnquiriesSearchStore.setState({
		filteredSaleIds,
		keyword,
		noResults: keyword ? !Object.values(filteredSaleIds).filter(Boolean).length : false,
	});
};

export const onSetSearch = (keyword: string) => EnquiriesSearchStore.setState({ search: keyword });

export const onItemToggle = (saleId: string) => {
	EnquiriesSelectStore.setState((state) => {
		const interactedSaleIds = { ...state.interactedSaleIds, [saleId]: !state.interactedSaleIds[saleId] };
		const selectedSaleIds = Object.entries(interactedSaleIds)
			.filter(([, value]) => Boolean(value))
			.map(([id]) => id);
		return { interactedSaleIds, selectedSaleIds };
	});
};

export const onToggleAll = (checked: boolean) => {
	const { enquiries, enquiriesMap } = EnquiriesStore.getState();
	const selectedPreToggle = enquiries.reduce((acc, { saleId }) => ({ ...acc, [saleId]: true }), {});
	const interactedSaleIds = checked ? selectedPreToggle : ({} as Record<string, boolean>);
	const selectedSaleIds = Object.entries(interactedSaleIds)
		.filter(([, value]) => Boolean(value))
		.map(([id]) => id);
	EnquiriesSelectStore.setState({ interactedSaleIds, selectedSaleIds });
	triggerSellerMessagingSelectAllCheckboxClickedEvent({
		enquiryIds: (checked ? selectedSaleIds : Object.keys(selectedPreToggle)).map(
			(saleId) => enquiriesMap[saleId].enquiryId,
		),
		isChecked: checked,
	});
};

export const enquirySelectionService = {
	onCreateEmailClick,
	onGetCommunicationData,
	onItemToggle,
	onMarkAsContactedClick,
	onRefetchCommunicationData,
	onSearchChange,
	onSetSearch,
	onToggleAll,
};
